import { call, put, takeLatest } from "redux-saga/effects";
import * as api from "~/store/faq/faqApi";
import * as types from "~/store/faq/faqType";

function* getAllFAQ() {
  try {
    const response = yield call(api.getAllFAQ);
    const { data } = response;
    if (response.status !== 200 || response.data.error_code)
      throw new Error("Lỗi server!");
    yield put({ type: types.GET_ALL_FAQ_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_ALL_FAQ_FAIL, error: "fail" });
  }
}

function* getFAQBySearch({ payload }) {
  // const { data } = yield call(api.getFAQBySearch, payload);
  // if (!data.error_code) {
  //   yield put({
  //     type: types.UPDATE_SHOWED_FAQ_BY_SEARCH_SUCCESS,
  //     payload: data
  //   });
  // } else
  //   yield put({
  //     type: types.UPDATE_SHOWED_FAQ_BY_SEARCH_FAIL,
  //     error: "fail"
  //   });
  try {
    const response = yield call(api.getFAQBySearch, payload);
    const { data } = response;
    if (response.status !== 200 || response.data.error_code)
      throw new Error("Lỗi server!");
    yield put({
      type: types.UPDATE_SHOWED_FAQ_BY_SEARCH_SUCCESS,
      payload: data
    });
  } catch (error) {
    yield put({
      type: types.UPDATE_SHOWED_FAQ_BY_SEARCH_FAIL,
      error: "fail"
    });
  }
}

export default function* root() {
  // yield take(types.GET_ALL_FAQ);
  // yield call(getAllFAQ);
  yield takeLatest(types.GET_ALL_FAQ, getAllFAQ);
  yield takeLatest(types.UPDATE_SHOWED_FAQ_BY_SEARCH, getFAQBySearch);
}
